import { IconButton, SvgIcon, type SxProps, type Theme } from '@mui/material';
import React from 'react';

import { borderRadius, palette, spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon, { type IconName } from '../../../utils/getMuiIcon';

interface NavIconProps {
	icon: IconName;
	onClick: () => void;
	navIconSx?: SxProps<Theme>;
}

const listItemIconStyles = {
	color: palette.text.secondary,
	padding: spaces.xs,
	'&:hover': {
		borderRadius: borderRadius.xs,
		backgroundColor: palette.primary.selected,
		'& svg': {
			color: palette.primary.main,
		},
	},
	'&:focus': {
		borderRadius: borderRadius.xs,
		backgroundColor: 'transparent',
		outline: 'none',
	},
	'&:focus:hover': {
		backgroundColor: palette.primary.selected,
	},
	'&:active': {
		backgroundColor: palette.common.white,
	},
};

const NavIcon: React.FC<NavIconProps> = ({ icon, onClick, navIconSx }) => {
	return (
		<IconButton sx={{ ...listItemIconStyles, ...navIconSx }} onClick={onClick}>
			<SvgIcon component={getMuiIcon(icon)} />
		</IconButton>
	);
};

export default NavIcon;
